import CreateVehicleHtml from './templates/vehicle.create.html';
import VehicleInfoHtml   from '../../app-lite/vehicles/templates/vehicle.info.html';
import VehicleListHtml   from './templates/vehicle.list.html';

export function VehicleSelectionCtrl (
  $q,
  $rootScope,
  $scope,
  $state,
  $translate,
  $urlService,
  blockUI,
  confirm,
  dvlaLookupApi,
  haynesProApi,
  jsonApi,
  messages,
  sessionObjAPI,
  vehicleRegistrationApi,
  vehicleApi,
  vehicleHistoryApi,
  workshopAPI
) {
  $scope.block                 = blockUI.instances.get('vehicleSelectionBlock');
  $scope.boxContentTemplateUrl = $scope.vehicle.id ? VehicleInfoHtml : VehicleListHtml;
  $scope.company               = sessionObjAPI.company();
  $scope.fleetCodeLabel        = $scope.company.company_variable_fields.fleet_code_name || $translate.instant('VEHICLE_SPACE.FLEET_CODE');
  $scope.originalVin           = $scope.vehicle.vin;
  $scope.regoLabel             = $scope.company.company_variable_fields.plate_number_name || sessionObjAPI.countrySettings().rego_label;
  $scope.vehicle.plate_state   = $scope.vehicle.plate_state || $scope.customer.state;
  $scope.vehicles              = [];
  $scope.vinLabel              = $scope.company.company_variable_fields.vin_name || $translate.instant('VEHICLE_SPACE.VIN');

  $scope.columns = [
    {
      field : 'plate_number',
      header: {
        text: $scope.regoLabel
      }
    },
    {
      field : 'make',
      header: {
        text: $translate.instant('VEHICLE_SPACE.MAKE')
      }
    },
    {
      field : 'model',
      header: {
        text: $translate.instant('VEHICLE_SPACE.MODEL')
      }
    },
    {
      field : 'model_code',
      header: {
        text: $translate.instant('VEHICLE_SPACE.MODEL_CODE')
      }
    },
    {
      field : 'model_series',
      header: {
        text: $translate.instant('VEHICLE_SPACE.MODEL_SERIES')
      }
    }
  ];

  if ($scope.company.company_settings.show_fleet_code) {
    $scope.columns.push({
      field : 'fleet_code',
      header: {
        text: $scope.fleetCodeLabel
      }
    });
  }

  $scope.filtering = {
    value: ''
  };

  $scope.tableSettings = {
    broadcast: 'filterVehicles',
    columns  : $scope.columns,
    empty    : {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_VEHICLES_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10, 25 ],
      queryCount: () => workshopAPI.get('/customers/vehicle_count', $scope.vehicle.customer_id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      direction: 'asc',
      enabled  : true,
      field    : 'plate_number'
    },
  };

  $scope.onRowClick = function (event) {
    $scope.onSelect({
      vehicle: event.row
    });
  };

  $scope.checkPlateNumber = function (form) {
    if ($scope.vehicle.plate_number) {
      return workshopAPI.get('/vehicle/verify_plate_uniqueness', $scope.vehicle.plate_number)
      .then(unique => {
        unique = jsonApi.parse(unique);

        form.plate_number.duplicate = !unique;

        return unique;
      });
    }

    form.plate_number.duplicate = false;

    return $q.when();
  };

  $scope.checkVin = function ( value ) {
    return $scope.originalVin === value
      ? $q.when(true)
      : vehicleApi.checkVinUniqueness(value);
  };

  $scope.close = function () {
    $scope.boxContentTemplateUrl = VehicleListHtml;
    $scope.$broadcast('open');
  };

  $scope.createFromOtherBranch = function () {
    vehicleApi.createVehicleFromOtherBranch($scope.vehicle.customer_id)
    .then(results => {
      $state.go($urlService.path().indexOf('invoice') > -1 ? 'app.invoice' : 'app.event', {
        customer_id: results.vehicle.customer_id,
        vehicle_id : results.vehicle.id
      });

      messages.show('Vehicle Saved', 'success');

      $scope.customerSelected(results.customer);
    });
  };

  $scope.createVehicle = function () {
    $scope.boxContentTemplateUrl = CreateVehicleHtml;
    $scope.$broadcast('open');
  };

  $scope.getVehicles = ( params ) => {
    return workshopAPI.get('/customers/vehicle_list_with_find', [
      $scope.vehicle.customer_id,
      $scope.filtering.value || '*',
      params.offset,
      params.pageSize,
      params.field,
      params.direction
    ]).then(function (vehicles) {
      $scope.vehicles = vehicles;
      return vehicles;
    });
  };

  $scope.init = function () {
    if ($scope.vehicle.customer_id && !$scope.vehicle.id) {
      $scope.getVehicles({
        direction: 'asc',
        field    : 'plate_number',
        offset   : 0,
        pageSize : 6
      });
    }

    workshopAPI.get('/system/vehicle_body_types/', null, 'bodyTypes')
    .then(types => {
      $scope.body_types = types;
    });

    workshopAPI.get('/system/state_types', null, 'states')
    .then(states => {
      $scope.states = states;
    });
  };

  $scope.isPlateNumberSearchAvailable = function () {
    return !$rootScope.Company.isDealer()
      && ( $rootScope.Company.hasIntegration('dvla-lookup')
        || $rootScope.Company.hasIntegration('vehicle-registrations')
        || $rootScope.Company.hasIntegration('carfax')
      );
  };

  $scope.save = function (form) {
    $scope.checkPlateNumber(form)
    .then(() => {
      return form.plate_number.duplicate
      ? confirm.generic($translate.instant('JS_SPACE.MESSAGES.VEHICLE_ALREADY_EXISTS', { label: $scope.regoLabel, rego: $scope.vehicle.plate_number }))
      : $q.when(true);
    })
    .then(() => workshopAPI.post('/vehicles', $scope.vehicle, 'vehicle'))
    .then(vehicle => {
      form.$setPristine();

      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.VEHICLE'), 'success');

      $scope.onSelect({ vehicle });
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.searchRegistration = function () {
    $scope.block.start();

    vehicleRegistrationApi.search($scope.vehicle)
    .then(vehicle => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.VEHICLE_DETAILS_ACQUIRED'), 'success');

      $scope.vehicle = vehicle;
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => {
      $scope.block.stop();
    });
  };

  $scope.vehicleFollowUpNotes = function (event_id) {
    vehicleApi.viewFollowUpNotes($scope.vehicle, event_id, 'event');
  };

  $scope.vehicleHistory = function () {
    vehicleHistoryApi.view($scope.vehicle);
  };

  $scope.vehicleHistoryReport = function() {
    vehicleHistoryApi.viewReport($scope.vehicle);
  };

  $scope.viewDiagnosticTool = function() {
    haynesProApi.openDiagnosticTool($scope.vehicle);
  };

  $scope.viewMotHistory = function() {
    dvlaLookupApi.viewMotHistory($scope.vehicle);
  };

  $scope.viewList = function () {
    if ($scope.vehicle.id) {
      $state.go('app.' + $scope.parent, {
        customer_id: $scope.vehicle.customer_id,
        id         : $scope.entity.id
      }, {
        inherit: false
      });

      return;
    }

    $scope.boxContentTemplateUrl = VehicleListHtml;
    $scope.$broadcast('open');
  };

  $scope.$watch('filtering.value', (newVal, oldVal) => {
    if (newVal !== oldVal) {
      window['filterVehicles']();
    }
  }, true);

  $scope.init();
};